import packageJson from "../../package.json";

const PRODUCT_COLORS = {
  mixora: {
    primary: "#7b61ff",
    primaryDark: "#5c46d6",
  },
  opt: {
    primary: "#c9a227",
    primaryDark: "#a6851f",
  },
};

export function resolveProductKey() {
  const envProduct = (process.env.VUE_APP_PRODUCT || "")
    .replace(/['"]/g, "")
    .trim()
    .toLowerCase();

  if (envProduct === "mixora" || envProduct === "opt") {
    return envProduct;
  }

  return packageJson.name === "mixora" ? "mixora" : "opt";
}

export function resolveSisterProductKey(productKey = resolveProductKey()) {
  return productKey === "opt" ? "mixora" : "opt";
}

export function resolveSisterProductUrl() {
  return (process.env.VUE_APP_SISTER_PRODUCT_URL || "")
    .replace(/['"]/g, "")
    .trim();
}

export function resolveAppPrimaryColor() {
  const key = resolveProductKey();
  return PRODUCT_COLORS[key].primary;
}

export function resolveAppPrimaryDarkColor() {
  const key = resolveProductKey();
  return PRODUCT_COLORS[key].primaryDark;
}
